<template>
  <div>
    <header>
      <h3 class="regHeader">
        <span class="imgDiv" v-on:click="backHistory">
          <!--<img src="@/assets/img/back.png" alt="">-->
          <van-icon size="22px" name="arrow-left" />
        </span>
        <span>注册</span></h3>
    </header>

    <form>
      <input type="number" class="mobile" v-model="form.userCode" placeholder="请输入手机号码">
      <p class="mobile-err err"></p>
      <div class="regcode divflex">
        <input type="number" class="codetxt" v-model="form.phoneCode" placeholder="请输入验证码">
        <input type="button" class="regcodebtn" v-on:click='onLogin':disabled="phoneBool"  v-model="countDown" value="获取验证码">
      </div>
      <p class="code-err err"></p>
      <input type="password" class="password" v-model="form.passWord1" placeholder="请输入密码">
      <p class="password-err err"></p>
      <input type="password" class="passwordagain" v-model="form.passWord2" placeholder="请再次输入密码">
      <p class="passwordagain-err err"></p>
      <div class="end">
        <span >
          <van-checkbox v-model="checked"></van-checkbox>
        </span>
        <span @click="close()">同意上社保注册协议</span>
        <!--<a href="javascript:;" class="openagree">同意上社保注册协议</a>-->
        <!--<a href="javascript:;" class="openagree">同意上社保注册协议</a>-->
      </div>
      <input type="button" value="注册" @click="register()" class="endButton">
    </form>
    <!-- 协议弹框 -->
    <div class="agreement" v-if="bool==true">
      <div class="agreemain">
        <h3>上社保网用户注册协议<a href="javascript:;" @click="close()" class="closeagree"></a></h3>
        <p class="shsj">本协议是用户与上社保网站（以下简称"本站"网址：www.shangshebao.com）所有者（所有者是指瑞美国际人力资源（北京）有限公司，以下简称上社保网）之间就上社保网站服务等相关事宜所订立的契约，请用户仔细阅读，<b>用户点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。</b></p>

        <h4>第1条 本站服务条款的确认和接纳</h4>
        <p>1.1本站各项服务归上社保网所有，用户同意所有注册协议条款并完成注册程序，才能成为本站正式用户。<b>用户确认本协议条款是处理双方权利义务契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</b></p>
        <p>1.2用户点击同意本协议的，即视为用户确认自己具有享受本站服务的相应的权利能力和行为能力，能够独立承担法律责任。</p>
        <p>1.3上社保网保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</p>

        <h4>第2条 本站服务</h4>
        <p>上社保网通过互联网为用户提供社保参保、续缴、补缴、补差、公积金缴纳等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。</p>

        <h4>第3条 用户信息</h4>
        <p>3.1用户应自行诚信向本站提供注册资料，用户确认其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且上社保网有权终止用户使用上社保网各项服务的权利。</p>
        <p>3.2上社保网尊重并保护用户的个人隐私权，为了给用户提供更准确、更有个性化的服务，上社保网将按本协议规定使用和披露用户个人信息。上社保网会不时更新本隐私权政策，用户在同意上社保网用户注册协议时，即视为用户已经同意本隐私权政策全部内容。</p>
        <p>3.3用户注册成功后，将产生用户名和密码等账户信息，用户可以根据本站规定改变用户的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。</p>
        <p>3.4用户同意，上社保网拥有通过邮件、短信电话等形式，向在本站注册、委托社保代缴的用户发送订单信息、促销活动等告知信息的权利（包括但不限于向用户发出产品和服务信息），或者与上社保网合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息。</p>
        <p>3.5用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。</p>
        <p>3.6在用户使用上社保网平台服务，或访问上社保网网站时，上社保网自动接收并记录的用户的浏览器和计算机上的信息，包括但不限于用户的IP地址、浏览器的类型、使用的语言、访问日期和时间等信息及用户需求的网页记录等数据。用户同意，上社保网有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</p>
        <p>3.7在如下情况下，上社保网将依据用户个人意愿或法律规定全部或部分披露用户个人信息：</p>
        <p>3.7.1经用户事先同意，向第三方披露；</p>
        <p>3.7.2如用户是适合的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
        <p>3.7.3根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
        <p>3.7.4如用户出现违反中国有关法律、法规或者上社保网服务协议或相关规则的情况，需要向第三方披露；</p>
        <p>3.7.5为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；</p>
        <p>3.7.6其它上社保网根据法律、法规或者网站政策认为应当的披露。</p>
        <p>3.8 Cookie的使用</p>
        <p>3.8.1在用户未拒绝接受cookies的情况下，上社保网会在用户的计算机上设定或取用cookies，以便用户能登录或使用依赖于cookies的上社保网平台的服务或功能。上社保网使用cookies可为用户提供更加周到的个性化服务，包括推广服务。</p>
        <p>3.8.2用户有权选择接受或拒绝接受cookies。用户可以通过修改浏览器设置的方式拒绝接受cookies。但如果用户选择拒绝接受cookies，则用户可能无法登录或使用依赖于cookies的上社保网平台的服务或功能。</p>

        <p>3.8.3通过上社保网所设cookies所取得的有关信息，将适用本政策。</p>
        <h4>第4条 信息安全</h4> <p>4.1请妥善保管用户上社保网平台的账户及密码信息。上社保网将通过各种技术手段、对用户密码进行加密等安全措施确保用户的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请用户注意在信息网络上不存在绝对完善的安全措施。</p>
        <p>4.2在使用上社保网平台服务进行网上交易时，用户不可避免的要向上社保网披露自己的个人信息，如姓名、身份证号码、联络方式等。请用户妥善保护自己的个人信息，仅在必要的情形下向他人提供。如用户发现自己的个人信息泄密，尤其是上社保网账户及密码发生泄露，请用户立即联络上社保网客服，以便上社保网采取相应措施。</p>
        <h4>第5条 用户依法言行义务</h4>
        <p class="shsj">本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
        <p>5.1不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</p>
        <p>5.2不得利用本站从事窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
        <p>5.3不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；</p>
        <p>5.4不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；</p>
        <p>5.5不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
        <p>5.6不得教唆他人从事本条所禁止的行为；</p>
        <p>5.7不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；</p>
        <p class="shsj">用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。</p>
        <h4>第6条 所有权及知识产权条款</h4>
        <p>6.1用户一旦接受本协议，即表明该用户主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给上社保网所有，用户同意上社保网有权就任何主体侵权而单独提起诉讼。</p>
        <p>6.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在上社保网网站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
        <p>6.3用户同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。</p>
        <p>6.4上社保网是本站的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知用户。在法律允许的最大限度范围内，上社保网对本协议及本站内容拥有解释权。</p>
        <p>6.5除法律另有强制性规定外，未经上社保网明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，上社保网有权追究其法律责任。</p>
        <p>6.6本站所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是上社保网或其内容提供者的财产，受中国和国际版权法的保护。本站上所有内容的汇编是上社保网的排他财产，受中国和国际版权法的保护。本站上所有软件都是上社保网或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</p>
        <p>6.7上社保网平台所有的服务项目、盈利模式、流程监控系统与所有程序均属于上社保网的知识产权。“上社保网”、“renrenbao”、”rrb”等中文名称、拼音及相关图形、标识等为上社保网注册商标。未经上社保网许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，上社保网将依法追究法律责任。 </p>

        <h4>第7条 责任限制及不承诺担保</h4>
        <p>7.1除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给用户的全部信息、内容、材料、产品（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。</p>
        <p>7.2除非另有明确的书面说明,上社保网不对本站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</p>
        <p>7.3上社保网不担保本站所包含或以其它方式通过本站提供给用户的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出电子信件、信息没有病毒或其他有害成分。</p>
        <p>7.4如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，上社保网会合理地尽力协助处理善后事宜。</p>
        <h4>第8条 协议更新及用户关注义务</h4>
        <p class="shsj">根据国家法律法规变化及网站运营需要，上社保网有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受上社保网网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。上社保网建议用户在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
        <h4>第9条 法律管辖和适用</h4>
        <p class="shsj">本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</p>
        <h4>第10条 其他</h4>
        <p>10.1上社保网网站所有者是指在政府部门依法许可或备案的上社保网网站经营主体。</p>
        <p>10.2上社保网尊重用户的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，上社保网将虚心接受并适时修改本协议及本站上的各类规则。</p>
        <p>10.3本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。</p>
        <p>10.4用户点击本协议下方的"同意并继续"按钮即视为用户完全接受本协议，在点击之前请用户再次确认已知悉并完全理解本协议的全部内容。</p>
        <button class="iknow closeagree" @click="close()">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        form:{
          userCode:'',//手机号
          password:'',
          phoneCode:'',//手机验证码
          phone:'',
          passWord1:'',
          passWord2:'',
        },
        checked: true,
        countDown:'获取验证码',
        num:60,//验证码倒计时
        bool:false,//验证码不可点
        phoneBool:false,
        code:"a",//接受手机验证码
        userId:'',
        passWord:"",
        password1:'',
        radio:"2"
      }
    },
    methods:{
      radioClick(){
        console.log(this.radio)
        this.showRadio=!this.showRadio
      },
     close(){
       this.bool=!this.bool
     },
      backHistory(){
        this.$router.go(-1)
      },
      onLogin(){//发送验证码
        if(this.form.userCode=='') return this.$toast("请输入手机号")
        this.$api.login({mobile:this.form.userCode}).then(res => {
//          resolve(res.data);
          this.userid=localStorage.getItem("userid")
          var _this=this
          console.log(res)
          if(res.status==200){
            this.countDown=this.num+"秒后重发"
            var time=setInterval(function () {
//              console.log(111)
//              console.log(_this.countDown)
              _this.num--
              if(_this.num==0){
                _this.countDown='获取验证码'
                _this.phoneBool=false
                clearInterval(time)
                _this.num=60
              }else {
                _this.countDown=_this.num+"秒后重发"
                _this.phoneBool=true
              }
            },1000)
            this.code=res.code
          }
        })
          .catch(err => {
//            reject(err.data)
          })
      },
      register(){//发送验证码
        console.log(this.radio)
        console.log(this.form.passWord1)
        console.log(this.form.passWord2)
        if(this.form.userCode=='') return this.$toast("请输入手机号")
        if(this.form.phoneCode=='') return this.$toast("请输入验证码")
        if(this.form.passWord1=='') return this.$toast("请输入密码")
        if(this.form.passWord1===this.form.passWord2){
          if(this.code!=this.form.phoneCode)return this.$toast("验证码错误")
          this.$api.regist(
            {
              "mobile":this.form.userCode,
            "password":this.form.passWord1
          }).then(res => {
            if(res.status==300){
              this.$toast("用户名已存在")
            }else if(res.status==200){
              this.$toast("注册成功")
              this.$router.push("/log")
            }
          })
            .catch(err => {
//            reject(err.data)
            })
        }else {
          this.$toast("俩次输入的密码不一致，请重新输入")
        }

      },
    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  @import '../assets/css/common.css';
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  @import '../assets/css/register.css';
.imgDiv{
  /*background: #6e9bcf*/
}
  .end{
    display: flex;
    align-items: center;
    padding-bottom: 1rem;
  }
  .imgDiv img{
    width: 20px;
    display: flex;
    align-items: center;
  }
  .regHeader{
   display: flex;
    padding-left: 15px;
  }
  /deep/.van-icon{
    top:2px
  }
  .endButton{
    display: block;
    width: 100%;
    /* margin: 0 auto; */
    height: 50px;
    background-color: #6e9bcf;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue